import { ReactNode } from "react";
import styles from "./SettingsSection.module.scss";

type SettingsSectionProps = {
  title: string;
  children: ReactNode;
};

export const SettingsSection = ({ title, children }: SettingsSectionProps) => {
  return (
    <div className={styles.section}>
      <h4>{title}</h4>
      {children}
    </div>
  );
};
